module.exports = __webpack_public_path__ + "media/images/web/avatar-daa11f470bf6128882ca3ec92ff94ddf.png";